import React, { useContext } from 'react';
import { Box, useThemeContext } from '@honda-canada/design-system-react';

import ActionLink from './ActionLink';
import HeaderContext from '../service/HeaderContext';
import { getGtmTitleValue } from '../../../utils/gtmEvents';

const MenuHeader = ({ parentDisplayName, ctaLink }) => {
  const colors = useThemeContext('colors');
  const { text, href, target, linktype, gtmBodyStyle, gtmTitle } = ctaLink;
  const { setActiveMenu } = useContext(HeaderContext);

  return (
    <Box pb="default">
      <ActionLink
        title={text}
        href={href}
        target={target}
        linktype={linktype}
        parentDisplayName={parentDisplayName}
        gtmTitle={getGtmTitleValue(gtmTitle, gtmBodyStyle)}
        withIcon
        tabIndex={0}
        onClick={() => setActiveMenu(null)}
        iconColor={colors.primary}
      />
    </Box>
  );
};

export default MenuHeader;
